import { render, staticRenderFns } from "./CustomSelect.vue?vue&type=template&id=de83ff6c&"
import script from "./CustomSelect.vue?vue&type=script&lang=js&"
export * from "./CustomSelect.vue?vue&type=script&lang=js&"
import style0 from "./CustomSelect.vue?vue&type=style&index=0&id=de83ff6c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports